module.exports = __webpack_public_path__ + "static/media/pannerelazeez.8e591eca.jpg";